import React from 'react'
import CenterModal from '../../../components/Modals/center-modal';
import { ReactComponent as SuccessIcon } from '../../../assets/sucessful.svg'

const OwnerSignupModal = ({ show, closeModal, setShowInvitMember }) => {

    return (
        <CenterModal show={show} closeModal={closeModal} modalClass='!max-w-[560px]  [&>*]:!border-0 [&>*]:!rounded-lg [&>*]:!overflow-hidden' backDropClassName={''}>
            <div className='!p-6'>
                <div className='flex flex-col items-center justify-center'>
                    <SuccessIcon />
                    <h3 className='text-xl font-semibold !mt-6'>
                        Welcome {localStorage.getItem('name')}
                    </h3>
                    <p className='mb-0 mt-2.5 text-[#667085] text-center'>Your signup is successful ,You can invite your team members from here. </p>

                    <button className='border rounded-lg gradient-blue text-white font-semibold text-center w-full !py-3 !mt-8' onClick={() => {
                        setShowInvitMember(true);
                        closeModal();
                    }}>Invite Team Members</button>
                    <button className='border rounded-lg inner-btn-shadow text-center w-full !py-3 !mt-4' onClick={closeModal}>Skip</button>
                </div>
            </div>
        </CenterModal>
    )
}

export default OwnerSignupModal